// Baut den Datensatz, den Kiosk und Offline-Fallback an den Server schicken.
import { result } from "./score.js"

export function runPayload(data, state, { token, nickname, completedAt }) {
  const r = result(data, state)
  return {
    token,
    industry: state.industry,
    employees: state.employees,
    guess: state.guess,
    nickname: nickname || null,
    completed_at: new Date(completedAt).toISOString(),
    result: { ...r, seed: state.seed }
  }
}
